var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 20.0999V62.9999C86 64.4851 85.41 65.9095 84.3598 66.9597C83.3096 68.0099 81.8853 68.5999 80.4 68.5999H21.7L4.00004 86.2999V20.0999C3.98675 19.3561 4.12179 18.6172 4.39726 17.9262C4.67274 17.2351 5.08312 16.6059 5.60446 16.0753C6.1258 15.5447 6.74763 15.1232 7.43366 14.8355C8.11968 14.5479 8.85615 14.3998 9.60004 14.3999H80.4C81.1439 14.3998 81.8804 14.5479 82.5664 14.8355C83.2524 15.1232 83.8743 15.5447 84.3956 16.0753C84.917 16.6059 85.3273 17.2351 85.6028 17.9262C85.8783 18.6172 86.0133 19.3561 86 20.0999Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.577422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9 63.7H140.4C141.885 63.7 143.31 64.2899 144.36 65.3402C145.41 66.3904 146 67.8147 146 69.3V135.6L128.3 117.9H69.5C68.0057 117.874 66.5814 117.262 65.534 116.196C64.4866 115.129 63.8998 113.695 63.9 112.2V76.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 51.2998H53.2001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 42.3999H72.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 33.5999H72.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6001 101H113.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6001 92.0999H132.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6001 83.2998H132.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubbles);
export default __webpack_public_path__ + "static/media/speech_bubbles.4528855b89ed91461dc86b83b1dc4a45.svg";
export { ForwardRef as ReactComponent };